import { render } from "./FullAsset.vue?vue&type=template&id=b9a6314a&scoped=true"
import script from "./FullAsset.vue?vue&type=script&lang=js"
export * from "./FullAsset.vue?vue&type=script&lang=js"

import "./FullAsset.vue?vue&type=style&index=0&id=b9a6314a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9a6314a"]])

export default __exports__